import common from './common'
import meta from './meta'
import cookies from './cookies'

export default {
  cookies,
  meta,
  common,
}
